import React, { useState } from 'react';

const DeleteAccountPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  // 1. Handle Login (to get the token)
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Replace with your actual login endpoint
      const response = await fetch('https://api.highendholidays.ae/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (data.token) {
        localStorage.setItem('token', data.token);
        setIsLoggedIn(true);
        setMessage({ type: 'success', text: 'Identity verified. You can now delete your account.' });
      } else {
        setMessage({ type: 'error', text: data.error || 'Login failed.' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Connection error.' });
    }
    setLoading(false);
  };

  // 2. Handle Deletion (Using your provided route)
  const handleDelete = async () => {
    if (!window.confirm("Warning: This will permanently delete your HighEnd Holidays account and all associated data. This cannot be undone.")) return;

    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const response = await fetch('https://api.highendholidays.ae/api/delete-account', {
        method: 'DELETE',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' 
        },
      });
      const data = await response.json();
      if (data.success) {
        localStorage.removeItem('token');
        setMessage({ type: 'success', text: 'Your account has been permanently deleted.' });
        setIsLoggedIn(false);
      } else {
        setMessage({ type: 'error', text: 'Failed to delete account.' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Error connecting to server.' });
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Account Deletion</h1>
        <p style={styles.description}>
          Pursuant to UAE Data Protection Law and Google Play policies, you may delete your 
          <strong> HighEnd Holidays</strong> account and all associated data here.
        </p>

        {message.text && (
          <div style={{ ...styles.alert, backgroundColor: message.type === 'error' ? '#fee2e2' : '#dcfce7' }}>
            {message.text}
          </div>
        )}

        {!isLoggedIn ? (
          <form onSubmit={handleLogin} style={styles.form}>
            <p style={styles.label}>Verify your identity to proceed:</p>
            <input 
              type="email" placeholder="Email Address" required style={styles.input}
              value={email} onChange={(e) => setEmail(e.target.value)} 
            />
            <input 
              type="password" placeholder="Password" required style={styles.input}
              value={password} onChange={(e) => setPassword(e.target.value)} 
            />
            <button type="submit" disabled={loading} style={styles.loginBtn}>
              {loading ? 'Verifying...' : 'Verify Identity'}
            </button>
          </form>
        ) : (
          <div style={styles.deleteSection}>
            <p style={styles.warningText}>
              All property bookings, "Read-to-Earn" credits, and personal profile information will be wiped.
            </p>
            <button onClick={handleDelete} disabled={loading} style={styles.deleteBtn}>
              {loading ? 'Processing...' : 'Permanently Delete My Account'}
            </button>
          </div>
        )}

        <div style={styles.footer}>
          <p>Need help? Contact <a href="mailto:info@backlinksai.in">info@backlinksai.in</a></p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f3f4f6', padding: '20px' },
  card: { backgroundColor: '#fff', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', maxWidth: '450px', width: '100%' },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', color: '#111827' },
  description: { fontSize: '14px', color: '#6b7280', marginBottom: '20px', lineHeight: '1.5' },
  alert: { padding: '12px', borderRadius: '8px', fontSize: '14px', marginBottom: '20px' },
  form: { display: 'flex', flexDirection: 'column', gap: '12px' },
  input: { padding: '12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '16px' },
  loginBtn: { padding: '12px', backgroundColor: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' },
  deleteBtn: { padding: '12px', backgroundColor: '#dc2626', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', width: '100%' },
  warningText: { color: '#b91c1c', fontSize: '13px', fontWeight: '600', marginBottom: '15px' },
  footer: { marginTop: '30px', textAlign: 'center', fontSize: '12px', color: '#9ca3af' }
};

export default DeleteAccountPage;